function t(t,s,n){const o=new URLSearchParams(null==s?void 0:s.split("?")[1]),e={};return n.forEach((s=>{const n=t&&t[s]||o.get(s);"string"==typeof n&&(e[s]=n)})),e}const s=()=>({statusCode:500});export{s as e,t as g};
//# sourceMappingURL=error-response-bbd8206b.js.map
